<script setup lang="ts">
import { ref } from 'vue'
import type { Swiper as SwiperType } from 'swiper'
import { useSwiper } from '~/composables/common/use-swiper'
import { sideBarCategories } from '~/resources/news'
import { SLUG_NEWS } from '~/constants'
defineProps({
  categorySlugCurrent: {
    type: String,
    default: SLUG_NEWS.PAGE
  }
})
const currentSlideIndex = ref()
const { modules } = useSwiper()
const onSwiper = (swiper: SwiperType): void => {
  currentSlideIndex.value = swiper
}
const selectCategory = (index: number): void => {
  currentSlideIndex.value?.slideTo(index)
}
</script>
<template>
  <div class="sidebar-category">
    <Swiper
      v-if="sideBarCategories?.length"
      :modules="modules"
      :slidesPerView="'auto'"
      :spaceBetween="8"
      @swiper="onSwiper"
    >
      <SwiperSlide
        ref="depositAmountSuggests"
        v-for="(category, index) in sideBarCategories"
        :key="index"
        class="sidebar-category__content"
        @click="selectCategory(index)"
      >
        <NuxtLink
          :to="`tin-tuc?cat=${category.slug}`"
          :class="['category', { active: categorySlugCurrent === category.slug }]"
        >
          <img class="category__icon" :src="category.icon" :alt="category.title" />
          <div class="category__label">{{ category.title }}</div>
        </NuxtLink>
      </SwiperSlide>
    </Swiper>
  </div>
</template>

<style scoped lang="scss">
@import '~scssAsset/mobile/news/sidebar-category.scss';
</style>
